import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { updateUser, usernameExists, sendWelcomeEmail } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import './EligeUsuario.css';

export const EligeUsuario = () => {
    const navigate = useNavigate();
    const { user, loading } = useAuth();

    const [state, setState] = useState(0);
    const [username, setUsername] = useState('');
    const [gender, setGender] = useState('');
    const [birthdate, setBirthdate] = useState('');
    const [province, setProvince] = useState('');
    const [maxDate, setMaxDate] = useState('');

    const provincesOfSpain = [
        "Álava", "Albacete", "Alicante", "Almería", "Asturias", "Ávila",
        "Badajoz", "Barcelona", "Burgos", "Cáceres", "Cádiz", "Cantabria",
        "Castellón", "Ciudad Real", "Córdoba", "Cuenca", "Gerona", "Granada",
        "Guadalajara", "Guipúzcoa", "Huelva", "Huesca", "Islas Baleares",
        "Jaén", "La Coruña", "La Rioja", "Las Palmas", "León", "Lérida",
        "Lugo", "Madrid", "Málaga", "Murcia", "Navarra", "Orense", "Palencia",
        "Pontevedra", "Salamanca", "Santa Cruz de Tenerife", "Segovia",
        "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia",
        "Valladolid", "Vizcaya", "Zamora", "Zaragoza"
    ];

    useEffect(() => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        setMaxDate(`${yyyy}-${mm}-${dd}`);
    }, []);

    // Inicializar campos con valores existentes del usuario para inputs controlados
    useEffect(() => {
        if (user) {
            setUsername(user.username || '');
            setGender(user.gender || '');
            setBirthdate(user.birthdate || '');
            setProvince(user.province || '');
        }
    }, [user]);

    useEffect(() => {
        if (!loading) {
            if (!user) {
                navigate('/login');
            } else if (user.processCompleted) {
                navigate('/');
            } else {
                setState(3); // Mostrar el formulario
            }
        }
    }, [user, loading, navigate]);

    async function handleContinue(e) {
        e.preventDefault();
        if (username && gender && birthdate && province) {
            const exists = await usernameExists(username);
            if (exists) {
                setState(5); // Nombre de usuario ya existe
            } else {
                const updatedUser = {
                    ...user,
                    username,
                    gender,
                    birthdate,
                    province,
                    processCompleted: true,
                };
                await updateUser(updatedUser);
                //console.log(user.email, username)
                await sendWelcomeEmail(user.email, username);
                setState(6); // Registro completado
            }
        }
    }

    if (loading || !user) return null;

    if (state === 6) {
        return (
            <div className="registro-exitoso">
                <h1>Felicidades, te has registrado correctamente. Ahora puedes buscar productos.</h1>
                <button><Link to='/' className="buscar-productos-link">Buscar productos</Link></button>
            </div>
        );
    }

    if (state === 3 || state === 5) {
        return (
            <div className="registro-container">
                <h1>Bienvenido <span className="display-name">{user.displayName}</span></h1>
                <p>Para terminar el proceso de registro, completa la información:</p>
                {state === 5 && <p className="error-message">El nombre de usuario ya existe, elige otro.</p>}
                <form onSubmit={handleContinue}>
                    <div className="input-container">
                        <label>Nombre de usuario:</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="username-input"
                            required
                        />
                    </div>

                    <div className="input-container">
                        <label>Fecha de nacimiento:</label>
                        <input
                            type="date"
                            value={birthdate}
                            onChange={(e) => setBirthdate(e.target.value)}
                            className="birthdate-input"
                            max={maxDate}
                            required
                        />
                    </div>

                    <div className="input-container">
                        <label>Género:</label>
                        <select
                            value={gender}
                            onChange={(e) => setGender(e.target.value)}
                            className="gender-select"
                            required
                        >
                            <option value="">Selecciona tu género</option>
                            <option value="male">Hombre</option>
                            <option value="female">Mujer</option>
                            <option value="other">Prefiero no decirlo</option>
                        </select>
                    </div>

                    <div className="input-container">
                        <label>Provincia:</label>
                        <select
                            value={province}
                            onChange={(e) => setProvince(e.target.value)}
                            className="province-select"
                            required
                        >
                            <option value="">Selecciona tu provincia</option>
                            {provincesOfSpain.map((prov, index) => (
                                <option key={index} value={prov}>{prov}</option>
                            ))}
                        </select>
                    </div>

                    <div className="button-container">
                        <button type="submit" className="continue-button">Continuar</button>
                    </div>
                </form>
            </div>
        );
    }

    return null;
};
